import { Button } from 'basic-ui-lib';
import commingSoon from 'assets/comming-soon.png';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <img src={commingSoon} alt="commingSoon" style={{ width: '100%', height: 'auto' }} />
      <Button onClick={() => navigate(-1)} type_second style={{ padding: '8px 16px' }} >Back</Button>
    </Container>
  );
};

export default NotFoundPage;
const Container = styled.div`
  height: 100vh;
  background: #fff;
`;